import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb';
import type { BreadcrumbItem } from '../breadcrumb/breadcrumb.models';

@Component({
  selector: 'ui-top-navbar',
  imports: [BreadcrumbComponent],
  templateUrl: './top-navbar.html',
  styleUrl: './top-navbar.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopNavbarComponent {
  /** Itens do breadcrumb a exibir, fornecidos pelo BreadcrumbService via shell. */
  breadcrumbItems = input<readonly BreadcrumbItem[]>([]);
}
